export function getTokenValueOrString(token: string | number | undefined, valuePostFix?: string | undefined) {
  if (!token) {
    return undefined;
  }
  if (typeof token === 'string') {
    return token;
  }
  return `${token}${valuePostFix}`;
}
